export default function mapObject(object, callback) {
  return Object.keys(object).map((key, index) => callback(object[key], key, index, object))
}
